
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ServerInterface } from '@/services/Server/Interfaces';

@Component({
  mixins: [Themeable],
})
export default class SyncServerDNSDialog extends Vue {
  @Prop() public servers!: ServerInterface;

  public server: string = '';

  public visible: boolean = true;

  public step: number = 0;

  public syncDNS(): void {
    this.$emit('syncServerDNS', this.server, this.step);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
